<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M22.6562 7.03125V17.9687C22.6562 19.2632 21.6069 20.3125 20.3125 20.3125H4.6875C3.39308 20.3125 2.34375 19.2632 2.34375 17.9687V7.03125M22.6562 7.03125C22.6562 5.73683 21.6069 4.6875 20.3125 4.6875H4.6875C3.39308 4.6875 2.34375 5.73683 2.34375 7.03125M22.6562 7.03125V7.28407C22.6562 8.09797 22.234 8.85359 21.5409 9.28015L13.7284 14.0878C12.9751 14.5514 12.0249 14.5514 11.2716 14.0878L3.45915 9.28015C2.76599 8.85359 2.34375 8.09797 2.34375 7.28407V7.03125"
				:stroke="color"
				stroke-width="1.5625"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgEmail',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
		strokeColor: {
			type: String,
			default: null,
		},
		strokeWidth: {
			type: Number,
			default: 1.5,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
